import XHR from '../http';
import {
  clearSessionEstablished,
  markSessionEstablished,
} from '../sessionState';

export const isEstablishedSessionResponse = (data = {}) => (
  data.session === 'established' || data.authenticated === true
);

/**
 * Bootstrap the BFF server session (MGOD-11701).
 *
 * Idempotent — the BFF treats repeat calls as session-reuse. Must complete
 * before any protected /api/mgo/* call. During the staged BFF rollout this
 * accepts both `{ session: "established" }` and the legacy
 * `{ authenticated: true }` response. The session ID is never persisted in
 * JavaScript; the HttpOnly JSESSIONID cookie remains authoritative.
 *
 * @return {Promise<Object>}
 */
export const bootstrapSession = () => XHR.post('/api/mgo/session').then(({ data }) => {
  if (!isEstablishedSessionResponse(data)) {
    throw new Error('BFF session bootstrap did not establish a session');
  }

  markSessionEstablished();
  return data;
}).catch((error) => {
  clearSessionEstablished();
  throw error;
});

export default bootstrapSession;
